<script setup>
import {useLanguageStore, useLoginStore} from "@/pinia";
import {computed} from "vue";

const languageStore = useLanguageStore();
const loginStore = useLoginStore();
const props = defineProps(['menuModalStatus','selectMenu'])
const emits =  defineEmits(['set_selectMenu'])
const clickMenu = (i)=>{
  emits('set_selectMenu',i.target.id)
}

// 권한 체크
const userRole = computed(() => loginStore.loginInfo?.role)
const isAdmin = computed(() => userRole.value === 'ADMIN')
const isEditor = computed(() => userRole.value === 'EDITOR')
const canShowMenu = computed(() => userRole.value === 'ADMIN' || userRole.value === 'EDITOR')

</script>

<template>
  <div class="menuArea" v-if="menuModalStatus && canShowMenu">
    <div class="menuTitle">
      {{languageStore.get('menu')}}
    </div>
    <div class="menus">
      <!-- ADMIN, EDITOR 접근 가능 메뉴 -->
      <router-link v-if="isAdmin || isEditor" to="/admin/video">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'videoManagement'}"
            id="videoManagement"
            @click="clickMenu">
          {{languageStore.get('videoManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin || isEditor" to="/admin/liveManagement">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'liveManagement'}"
            id="liveManagement"
            @click="clickMenu">
          {{languageStore.get('liveBroadcastManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin || isEditor" to="/admin/meeting">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'meetingManagement'}"
            id="meetingManagement"
            @click="clickMenu">
          {{languageStore.get('meetingManagement')}}
        </div>
      </router-link>
      <!-- ADMIN 전용 메뉴 -->
      <router-link v-if="isAdmin" to="/admin/ageSession">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'ageSessionManagement'}"
            id="ageSessionManagement"
            @click="clickMenu">
          {{languageStore.get('meetingCodeManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin" to="/admin/log">
        <div
            class="menu"
            id="log"
            :class="{selectedMenu :selectMenu == 'log'}"
            @click="clickMenu">
          {{languageStore.get('logManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin" to="/admin/comCode">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'comCode'}"
            id="comCode"
            @click="clickMenu">
          {{languageStore.get('basicCodeManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin" to="/admin/user">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'user'}"
            id="user"
            @click="clickMenu">
          {{languageStore.get('userManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin" to="/admin/apikey">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'apiKeyManagement'}"
            id="apiKeyManagement"
            @click="clickMenu">
          {{languageStore.get('snsConnectionManagement')}}
        </div>
      </router-link>
      <router-link v-if="isAdmin" to="/admin/statistics">
        <div
            class="menu"
            :class="{selectedMenu :selectMenu == 'statistics'}"
            id="statistics"
            @click="clickMenu">
          {{languageStore.get('statistics')}}
        </div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
  .menuArea{
    position: absolute;
    right: 1px;
    top : 84px;
    z-index: 99;
    background: white;
    display: flex;
    flex-direction: column;
    width: 8vw;
    border : 1px solid #C7C7C7;
  }
  .menu{
    padding: 10px 0px 10px 10px;
    font-size: 0.9rem;
    cursor: pointer;
    width: 100%;
    display: flex;
    height: 100%;
  }
  .selectedMenu{
    padding: 10px 0px 10px 10px;
    font-size: 0.9rem;
    cursor: pointer;
    width: 100%;
    display: flex;
    height: 100%;
    background: #052C65;
    color: white;
  }
  .menu:hover{
    background: #052C65;
    color: white;
  }
  .menuTitle{
    border : 1px solid #C7C7C7;
    font-size: 1.2rem;
    width: 100%;
    display: flex;
    padding: 10px 0 10px 0;
    justify-content: center;
  }
</style>